module.exports = __webpack_public_path__ + "img/icon-63.242e874e.svg";